module.exports = __webpack_public_path__ + "static/media/business_development.44b0a6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/business_development.png
// module id = 497
// module chunks = 0